import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
  target?: string;
  rel?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  target,
  rel,
  ...props
}: ButtonProps) {
  const sharedClasses = `
    relative group overflow-hidden rounded-sm
    bg-[#111827] border border-[#d4a853]/50
    text-[#f0c674] font-mono font-bold tracking-widest uppercase text-sm md:text-base
    py-4 px-8 transition-all duration-300
    hover:border-[#d4a853] hover:text-[#fff] hover:box-glow
    inline-block text-center no-underline
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const inner = <>
      <div className="absolute inset-0 bg-gradient-to-r from-[#b8860b]/0 via-[#b8860b]/10 to-[#b8860b]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-254" />
      <span className="relative z-10" data-id="element-255">{children}</span>
    </>;
  if (href) {
    return <motion.a href={href} target={target || '_blank'} rel={rel || 'noopener noreferrer'} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClasses} data-id="element-256">
        {inner}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClasses} {...props} data-id="element-257">
      {inner}
    </motion.button>;
}